import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class QuotaMonitorService {
	
  
  async getLiveQuotas() {
    return await Api().get(`${API_URL}/quotaMonitor/getLiveQuotas`, { headers:  authHeader() as any });      
  }

  async updateQuota(quotas: any) {
    return await Api().put(`${API_URL}/quotaMonitor/batch`, quotas, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }
}

export default new QuotaMonitorService();